import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { bindAffiliateReferral } from '../api/affiliate_api';
import { useAppSelector } from '../store/hooks';

const PENDING_REFERRAL_KEY = 'fable-pending-affiliate-referral-v1';

const AffiliateAttributionListener = () => {
  const location = useLocation();
  const userId = useAppSelector(state => state.app.userId);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const referralCode = params.get('ref') || params.get('deep_link_sub1') || params.get('af_sub1');
    if (referralCode) window.localStorage.setItem(PENDING_REFERRAL_KEY, referralCode);
  }, [location.search]);

  useEffect(() => {
    if (!userId) return;
    const referralCode = window.localStorage.getItem(PENDING_REFERRAL_KEY);
    if (!referralCode) return;
    bindAffiliateReferral(referralCode)
      .then(result => {
        if (result.attributed || result.reason === 'already_attributed') {
          window.localStorage.removeItem(PENDING_REFERRAL_KEY);
        }
      })
      .catch((error: any) => {
        const reason = error?.response?.data?.reason;
        if (['already_attributed', 'self_referral', 'same_device', 'device_reused', 'account_too_old'].includes(reason)) {
          window.localStorage.removeItem(PENDING_REFERRAL_KEY);
        }
      });
  }, [userId]);

  return null;
};

export default AffiliateAttributionListener;
